import axios from "axios";
import Swal from "sweetalert2";
import { swalError } from "@/plugins/swalHelper";

const baseURL = process.env.VUE_APP_BASE_URL;
const apiKey = process.env.VUE_APP_API_KEY;

axios.interceptors.request.use((config) => {
  config.baseURL = baseURL;
  config.headers["x-api-key"] = apiKey;
  config.headers["x-app-version"] = process.env.VUE_APP_VERSI;
  config.headers["x-app-type"] = process.env.VUE_APP_TYPE;

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status, data } = error.response;

    if (status == 423) {
      Swal.fire({
        title: "Info",
        text: "Session Habis, Silahkan Login Kembali",
        icon: "info",
        showCancelButton: false,
        showConfirmButton: false,
      });
      setTimeout(() => {
        Swal.close();
        localStorage.removeItem("userData");
        window.location.reload();
      }, 3000);
    }

    if (status == 426) {
      Swal.fire({
        title: "Info",
        text: "Versi Baru Tersedia, Refresh Halaman",
        icon: "info",
        showCancelButton: false,
        showConfirmButton: false,
      });
      setTimeout(() => {
        Swal.close();
        caches
          .keys()
          .then(function (names) {
            for (let name of names) {
              caches.delete(name);
            }
          })
          .then(() => {
            window.location.reload();
          });
      }, 3000);
    }

    if (status == 429) {
      swalError(data.message || "Terjadi kesalahan");
    }

    if (status >= 500) {
      swalError(data.message || "Terjadi kesalahan");
    }

    return Promise.reject(error);
  }
);
